<template>
  <div class="bodybox">
    <div class="columnBox">
      <div class="columnBoxInnner">
        <div class="columnBoxInnnerList">
          <div v-for="(item,index) in columnlist" :key="index" :class="currrentcolumn==index?'activename':'column_a'" @click="changeNowColumn(item.value,index)">
            <span class="nameshow">{{ item.name }}</span><span v-show="index<columnlist.length-1" class="a_span">/</span>
          </div>
        </div>
      </div>
      <Centerlistnews :columnlist="currentData" />
      <div v-if="loadAll" class="atfoot loadMore">
        已经到底部了
      </div>
      <div v-else class="loadMore" @click="addMore">
        加载更多>>
      </div>
    </div>
  </div>
</template>
<script>

import Centerlistnews from '@/components/centerlist_specialTopic'
import { addspecialData } from '@/api/api.js'

export default {
  components: { Centerlistnews },
  props: ['columnlist', 'alldata'],
  data() {
    return {
      currentPage: 1,
      specialTypeIds: '',
      currrentcolumn: 0,
      loadAll: false,
      page: 1,
      currentData: this.alldata.specialPage.listMapData
    }
  },
  computed: {

  },
  created() {

  },
  mounted() {
    this.page = this.alldata.specialPage.page
    if (this.page == this.currentPage * 1) {
      this.loadAll = true
    }
  },
  methods: {
    changeNowColumn: function(ID, index) {
      this.loadAll = false
      var obj = {}
      obj.index = '1'
      obj.size = '8'
      if (ID) {
        obj.specialTypeIds = ID
      }
      this.specialTypeIds = ID
      this.currentPage = 1
      this.currrentcolumn = index
      addspecialData(obj).then(res => {
        this.currentData = []
        this.currentData = this.currentData.concat(res.data.listMapData)
        this.page = res.data.page
        if (this.currentPage >= this.page) {
          this.loadAll = true
        }
      })
    },
    // /加载更多
    addMore: function() {
      var obj = {}
      if (this.specialTypeIds) {
        obj.specialTypeIds = this.specialTypeIds
      }
      obj.index = this.currentPage * 1 + 1
      obj.size = '12'
      addspecialData(obj).then(res => {
        this.currentData = this.currentData.concat(res.data.listMapData)
        this.currentPage = this.currentPage * 1 + 1
        this.page = res.data.page
        if (this.currentPage >= this.page) {
          this.loadAll = true
        }
      })
    }
  }

}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .columnBoxInnner{
    height: 60px;
    line-height: 60px;
    text-align: center;
    background-color: #fff;
  }
    .bodybox{
        background-color: #fafafa;
    }
    .columnBox{
        /*margin: 20px auto;*/
        padding-top: 20px;
        .activename{
            display: inline-block;
            cursor: pointer;
            .a_span{
                margin: 0 16px;
            }
            .nameshow{
                color: #ed4040;
                font-size: 16px;
               font-weight: 600;
            }

        }
        .column_a{
            display: inline-block;
            cursor: pointer;
            font-size: 16px;
            .a_span{
                margin: 0 16px;
            }
            .nameshow{
                font-size: 16px;
                color: #333333;
              font-weight: 600;
                &:hover{
                    color: #ed4040;
                }
            }
        }
       .loadMore{
        height: 45px;
        line-height: 45px;
        font-size: 14px;
        color: #999999;
        background-color: #fff;
        border: 1px solid #e5e5e5;
        border-radius: 3px;
        cursor: pointer;
        display:inline-block;
        width: 100%;
        transition: 0.5s;
         margin-bottom: 50px;
         text-align: center;
        &:hover{
          color: #ed4040;
          border: 1px solid #ed4040;
        }
      }
        .atfoot{
            cursor: auto;
        }
    }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {

    .columnBoxInnner{
      width: 100%;
      overflow: hidden;
      overflow-x: auto;
      .columnBoxInnnerList{
        white-space: nowrap;
        padding: 0 20px;
      }
    }
  }
</style>
